import { useMediaQuery } from "react-responsive";

const useResponsiveness = () => {
	const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });

	return { isTabletOrMobile };
};

export default useResponsiveness;
